import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import styles from "./modal.module.css";
import ReactHtmlParser from "react-html-parser";
import { AiOutlineClose } from "react-icons/ai";

export default function GuideModal({ guideModal }) {
  // Nút hướng dẫn
  const [openModal, setOpenModal] = React.useState(false);

  const toggle = () => setOpenModal(!openModal);
  return (
    <>
      <div>
        <Button
          type="button"
          color="info"
          hidden={guideModal && guideModal.length > 0 ? false : true}
          onClick={toggle}
          disabled={guideModal && guideModal.length > 0 ? false : true}
          style={{
            cursor: guideModal && guideModal.length > 0 ? "pointer" : "no-drop",
          }}
        >
          Hướng dẫn
        </Button>
        <div>
          <Modal
            isOpen={openModal}
            toggle={toggle}
            className={`${styles.modalDialog} ${styles.guideModal}`}
            backdrop={false}
          >
            <ModalHeader className={`${styles.modalHeader}`}>
              {guideModal?.[0]?.title}

              <AiOutlineClose
                size={35}
                onClick={toggle}
                className={`${styles.spanX}`}
              />
            </ModalHeader>
            <ModalBody>
              {ReactHtmlParser(guideModal?.[0]?.description)}
            </ModalBody>
            <ModalFooter>
              <Button color="info" onClick={toggle}>
                Đóng
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    </>
  );
}
